import { makeStyles } from '@material-ui/core/styles';
import { onoSvg } from "../../../assets/images/images";
export const useStyles = makeStyles((theme) => ({

  // ono_field: {
  //   background: `url("${onoSvg}")`,
  // },
}));    
